import L from 'leaflet';
import { logEvent } from '../../Util';

export interface LocateControl extends L.Control, L.Evented {
    new (options?: L.ControlOptions): this;
    initializeView: (validBounds: L.LatLngBounds) => LocateControl;
}

export const LocateControl: LocateControl = L.Control.extend({
    includes: L.Evented.prototype,

    options: {
        position: 'bottomright',
        title: '<span class="icon-target"></span>',
    },

    onAdd: function (map) {
        const container = L.DomUtil.create('div', 'locate-bar');
        const btn = L.DomUtil.create('a', 'locate-button', container);
        btn.innerHTML = this.options.title;
        this._map = map;
        btn.setAttribute('title', 'Gå till nuvarande position');
        L.DomEvent.addListener(
            btn,
            'click',
            function (e) {
                this.showCurrent();
                L.DomEvent.stopPropagation(e);
            },
            this,
        );

        return container;
    },

    initializeView: function (validBounds) {
        let viewSet = false;

        function locationFound(e) {
            if (!viewSet) {
                if (validBounds.intersects(e.bounds)) {
                    this._map.fitBounds(e.bounds, { maxZoom: 12 });
                    viewSet = true;
                }
            }

            this.setLocationMarker(e.latlng);

            removeListeners.call(this);

            logEvent('Map', 'My position found');
        }

        function locationError() {
            const lm = this._locationMarker;

            if (lm) {
                this._map.removeLayer(lm);
                delete this._locationMarker;
            }

            removeListeners.call(this);

            logEvent('Map', 'My position error');
        }

        function removeListeners() {
            this._map.off('locatecontrol', locationFound, this);
            this._map.off('locationerror', locationError, this);
        }

        this._map.on('locationfound', locationFound, this);
        this._map.on('locationerror', locationError, this);

        this._map.locate({
            watch: false,
            timeout: 5000,
        });

        return this;
    },

    showCurrent: function () {
        function locationFound(e) {
            this._map.fitBounds(e.bounds, { maxZoom: 9 });
            this.setLocationMarker(e.latlng);
            unregister.call(this);
        }

        function unregister() {
            this._map.off('locationfound', locationFound, this);
            this._map.off('locationerror', unregister, this);
        }

        this._map.locate();
        this._map.on('locationfound', locationFound, this);
        this._map.on('locationerror', unregister, this);

        return this;
    },

    setLocationMarker: function (latLng) {
        const lm = this._locationMarker;

        if (lm) {
            this._map.removeLayer(lm);
        }

        this._locationMarker = L.circleMarker(latLng, {
            radius: 6,
            className: 'marker-myposition',
        })
            .on(
                'click',
                function () {
                    this.fire('locationmarkerclicked', { latlng: this._locationMarker.getLatLng() });
                },
                this,
            )
            .addTo(this._map);

        return this;
    },
}) as unknown as LocateControl;
